<template>
  <vue-header-b2b
    :categorias="categorias"
    :logo="configEmpresa.logo"
    :logoUrl="logoUrl"
    :logoDarkUrl="logoDarkUrl"
    :acessosEmpresa="$empresaUtils"
    :tiposAcesso="$tipoAcesso"
    :configEmpresa="configEmpresa"
    :t="$t"
    :exibirBarraBuscaHeader="true"
    :avatar="avatar"
    :avatarPadrao="avatarPadrao"
    :usuario="user.user"
    :temPermissaoAdmin="temPermissaoAdmin"
    :modoNoturno="darkMode"
    @logout="logout"
    @alternarDarkMode="toggleDarkMode"
    @buscaGeralPlataforma="generalSearchPlataform"
  >
    <notifications v-if="user.user.email !== 'visitante@jaleko.com.br'" ></notifications>
  </vue-header-b2b>
</template>

<script>
import LoginUtils from '@/core/utils/login-utils'
import ImageUtils from '@/core/utils/image-utils'
import VueHeaderB2b from '@jaleko/header/src/vue-header-b2b.vue'
import Notifications from '@/components/notifications'
import { TipoPerfilUtil } from '@/core/utils/tipo-perfil-utils'
import PlataformApi from "@/services/plataformApi"
import { mapState } from 'vuex'
import '@jaleko/header/src/scss/vue-header-b2b.scss'

export default {
  name: 'AppHeaderB2b',
  components: {
    VueHeaderB2b,
    Notifications
  },
  data () {
    return {
      searchTerm: '',
      darkMode: false,
      rotasRestritasAcesso: [],
      avatar: '',
      professoresJalekoEmpresaId: 23,
      textosConfiguraveis: '',
      categorias: []
    }
  },
  created () {
    this.textosConfiguraveis = this.configEmpresa.textosConfiguraveis
    this.menuBackgroundColor = this.configEmpresa.menuBackgroundColor ? this.configEmpresa.menuBackgroundColor : '#363953'
    this.avatar = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${this.user.user.logadoPelaEmpresa.id}/avatar.png`
  },
  async mounted () {
    if (this.user.user.modo_noturno === 1) {
      this.darkMode = true
    } else {
      this.darkMode = false
    }
    const categorias = await PlataformApi.listarCategorias();
    this.categorias = categorias.categorias;
  },
  watch: {
    darkMode: function () {
      if (this.darkMode) {
        this.user.user.modo_noturno = 1
        document.body.classList.add('darkMode')
      } else {
        this.user.user.modo_noturno = 0
        document.body.classList.remove('darkMode')
      }
    }
  },
  computed: {
    ...mapState({
      configEmpresa: (state) => state.empresa.configEmpresa,
      user: (state) => state.user.infoUser,
      newNotification: (state) => state.notification.newNotification
    }),
    avatarPadrao: function () {
      if (this.user.user && this.user.user.avatar) {
        return ImageUtils.getFullUrlImage(this.user.user.avatar)
      }
      return ''
    },
    circleClass () {
      return this.newNotification ? 'fa-circle' : null
    },
    isPwa() {
      return LoginUtils.isPwa();
    },
    logoUrl: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}empresas/logos/${this.user.user.logadoPelaEmpresa.id}/light.png`
    },
    logoDarkUrl: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}empresas/logos/${this.user.user.logadoPelaEmpresa.id}/dark.png`
    },
    temPermissaoAdmin: function () {
      if (TipoPerfilUtil.isMaster(this.user.user.perfil_id) || TipoPerfilUtil.isAdmin(this.user.user.perfil_id) || TipoPerfilUtil.isAdminRestrito(this.user.user.perfil_id) || TipoPerfilUtil.isMasterJaleko(this.user.user.perfil_id) || TipoPerfilUtil.isProfessor(this.user.user.perfil_id) || TipoPerfilUtil.isAnalista(this.user.user.perfil_id)) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    logout: function () {
      LoginUtils.logout()
      if (LoginUtils.isPwa()) {
        window.location = '/flashcards/login'
      }
      else {
        window.location = '/logout'
      }
    },

    generalSearchPlataform (searchTerm) {
      if (searchTerm !== '') {
        window.location = `/busca?q=${searchTerm}`
      }
    },

    toggleDarkMode () {
      this.darkMode = !this.darkMode
      this.$store.dispatch('toggleDarkMode', this.darkMode)
    },

    redirectToCms: async function () {
      await this.$store.dispatch('tokenSSO')
      let token = this.$store.getters.tokenSSO
      window.open(process.env.VUE_APP_JALEKO_CMS_URL + '/login/token/' + token + '?empresaId=' + this.user.user.logadoPelaEmpresa.id, '_blank')
    },

    redirectToWL: async function (empresaId) {
      await this.$store.dispatch('urlWLSSO', empresaId)
      let url = this.$store.getters.urlWLSSO
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>

</style>
